import { render, staticRenderFns } from "./ProductWizardModal.vue?vue&type=template&id=19e608fc&scoped=true"
import script from "./ProductWizardModal.vue?vue&type=script&lang=js"
export * from "./ProductWizardModal.vue?vue&type=script&lang=js"
import style0 from "./ProductWizardModal.vue?vue&type=style&index=0&id=19e608fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e608fc",
  null
  
)

export default component.exports